/** lucide icon and tint per file family (spec, Icon families). lucide-react 0.518. */

import {
  File,
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
  Presentation,
} from 'lucide-react';

import { fileFamily, type FileFamily } from '../../utils/attachments';

const BY_FAMILY: Record<FileFamily, { Icon: typeof File; tint: string }> = {
  pdf: { Icon: FileText, tint: 'text-red-600' },
  document: { Icon: FileText, tint: 'text-blue-600' },
  spreadsheet: { Icon: FileSpreadsheet, tint: 'text-green-600' },
  presentation: { Icon: Presentation, tint: 'text-orange-600' },
  archive: { Icon: FileArchive, tint: 'text-slate-600' },
  image: { Icon: FileImage, tint: 'text-purple-600' },
  video: { Icon: FileVideo, tint: 'text-slate-600' },
  audio: { Icon: FileAudio, tint: 'text-slate-600' },
  code: { Icon: FileCode, tint: 'text-slate-600' },
  other: { Icon: File, tint: 'text-slate-600' },
};

export function FileTypeIcon({
  fileName,
  className = 'h-8 w-8',
}: {
  fileName: string;
  className?: string;
}) {
  const { Icon, tint } = BY_FAMILY[fileFamily(fileName)];
  return <Icon className={`${className} ${tint}`} aria-hidden />;
}
